import {HttpError} from './http-error';

export class FindHttpError extends HttpError { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/error/find-http-error.ts